// extracted by mini-css-extract-plugin
export default {"frame_outer":"Frame_frame_outer__rJ77S","frame_inner":"Frame_frame_inner__sdWAj"};